import React from "react";
import { useSelector } from "react-redux";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import PreviewCard from "../previewCard/PreviewCard";
import { ParsedRecord } from "../../../types/airtable";
import { RootState } from "../../../store";

import "./RecordsPanel.scss";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.default
    }
  })
);

interface IHandleSelectRecord {
  (record: ParsedRecord): void;
}

const RecordsPanel = ({
  records,
  handleSelectRecord
}: {
  records: ParsedRecord[];
  handleSelectRecord: IHandleSelectRecord;
}) => {
  const classes = useStyles();

  const clickedPeak = useSelector(
    (state: RootState) => state.selection.selection.clickedPeak
  );

  return (
    <div id="records-panel" className={classes.root}>
      {records.map((record) => {
        return (
          <PreviewCard
            focused={record.PEAK_ID === clickedPeak}
            record={record}
            key={record.PEAK_ID}
            onClick={() => handleSelectRecord(record)}
          />
        );
      })}
    </div>
  );
};

export const MemoizedRecordsPanel = React.memo(RecordsPanel);
